import { RootState } from 'store';
// Models
import IDestinationType from 'models/DestinationType';

export const selectAllDestinationTypes = (state:RootState) => state.destinationTypes.destinationTypes;

export const selectDestinationTypes = (state: RootState) => state.destinationTypes.destinationTypes?.map((destinationType: IDestinationType) => (
  { value: destinationType.id, label: destinationType.name }
));
